export const SET_TITLE = 'SET_TITLE';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_VISIBILITY = 'SET_VISIBILITY';
export const SET_TYPE = 'SET_TYPE';
export const RESET_ALL = 'RESET_ALL';
